import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Ajustes de rota antes de iniciar o React
(() => {
  const { hash, search } = window.location;
  console.log('🔍 [index.tsx] URL atual:', window.location.href);
  console.log('🔍 [index.tsx] Search params:', search);
  console.log('🔍 [index.tsx] Hash:', hash);

  // 1) Se houver parâmetro redirect, aplicá-lo imediatamente
  const params = new URLSearchParams(search);
  const redirectParam = params.get('redirect');

  console.log('🔍 [index.tsx] redirect param:', redirectParam);

  if (redirectParam) {
    const decoded = decodeURIComponent(redirectParam);

    // Preserva TODOS os outros parâmetros (tarefaId, canalId, topicoId,
    // avisoId, etc.), não só tarefaId — senão link de email pra tópico/aviso
    // perdia o identificador antes mesmo do React montar.
    const restante = new URLSearchParams(params);
    restante.delete('redirect');
    const query = restante.toString();
    const newUrl = query ? `${decoded}?${query}` : decoded;
    console.log('✅ [index.tsx] Redirecionando para:', newUrl);

    // Marcar que veio de email para não mostrar popup de tarefas pendentes
    if (query) {
      sessionStorage.setItem('emailRedirect', 'true');
      console.log('✅ [index.tsx] Marcado emailRedirect no sessionStorage');
    }

    window.history.replaceState(null, '', newUrl + window.location.hash);
    return; // Já redirecionamos; não precisa processar hash abaixo
  }

  // 2) Se a URL veio com hash-style (#/rota), converte para path real
  if (hash && hash.startsWith('#/')) {
    const newPath = hash.substring(1); // remove '#'
    console.log('✅ [index.tsx] Convertendo hash para path:', newPath);
    window.history.replaceState(null, '', newPath);
  }
})();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
